const UomTypes = {
  GET_UOM_LIST_REQUEST: 'GET_UOM_LIST_REQUEST',
  GET_UOM_LIST_SUCCESS: 'GET_UOM_LIST_SUCCESS',
  GET_UOM_LIST_ERROR: 'GET_UOM_LIST_ERROR',

  ADD_UOM_REQUEST: 'ADD_UOM_REQUEST',
  ADD_UOM_SUCCESS: 'ADD_UOM_SUCCESS',
  ADD_UOM_ERROR: 'ADD_UOM_ERROR',

  GET_UOM_ITEM_REQUEST: 'GET_UOM_ITEM_REQUEST',
  GET_UOM_ITEM_SUCCESS: 'GET_UOM_ITEM_SUCCESS',
  GET_UOM_ITEM_ERROR: 'GET_UOM_ITEM_ERROR',

  UPDATE_UOM_REQUEST: 'UPDATE_UOM_REQUEST',
  UPDATE_UOM_SUCCESS: 'UPDATE_UOM_SUCCESS',
  UPDATE_UOM_ERROR: 'UPDATE_UOM_ERROR',

  DELETE_UOM_REQUEST: 'DELETE_UOM_REQUEST',
  DELETE_UOM_SUCCESS: 'DELETE_UOM_SUCCESS',
  DELETE_UOM_ERROR: 'DELETE_UOM_ERROR',

  GET_ACTIVE_UOM_REQUEST: 'GET_ACTIVE_UOM_REQUEST',
  GET_ACTIVE_UOM_SUCCESS: 'GET_ACTIVE_UOM_SUCCESS',
  GET_ACTIVE_UOM_ERROR: 'GET_ACTIVE_UOM_ERROR',

  UPDATE_UOM_QUERY_PARAMS: 'UPDATE_UOM_QUERY_PARAMS'
};

export default UomTypes;
